import { appStorage } from './betaStorage'
export type MedicationReminder = {
  id: string
  name: string
  dose?: string
  instructions?: string
  time: string
  reminderEnabled: boolean
  takenDate?: string
  takenAt?: string
  lastAlertDate?: string
}

const STORAGE_KEY = 'schub.alexMedications.v1'

const defaults: MedicationReminder[] = [
  { id: 'med-morning', name: 'Morning medication', dose: 'As prescribed', instructions: 'Take with breakfast', time: '08:00', reminderEnabled: true },
  { id: 'med-evening', name: 'Evening medication', dose: 'As prescribed', instructions: 'Take with food', time: '19:00', reminderEnabled: true },
]

export function todayKey(date = new Date()) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function loadMedications(): MedicationReminder[] {
  try {
    const raw = appStorage.getItem(STORAGE_KEY)
    if (!raw) return defaults
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : defaults
  } catch {
    return defaults
  }
}

export function saveMedications(items: MedicationReminder[]) {
  appStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  window.dispatchEvent(new CustomEvent('schub:medications-change'))
}

export function formatMedicationTime(value: string) {
  const [h, m] = value.split(':').map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return value
  const suffix = h >= 12 ? 'PM' : 'AM'
  const hour = h % 12 || 12
  return `${hour}:${String(m).padStart(2, '0')} ${suffix}`
}

export function nextMedication(items: MedicationReminder[], now = new Date()) {
  const minutesNow = now.getHours() * 60 + now.getMinutes()
  const today = todayKey(now)
  return items
    .filter(item => item.takenDate !== today)
    .map(item => {
      const [h, m] = item.time.split(':').map(Number)
      return { item, minutes: h * 60 + m }
    })
    .filter(entry => Number.isFinite(entry.minutes) && entry.minutes >= minutesNow)
    .sort((a, b) => a.minutes - b.minutes)[0]?.item
}

